import { render, staticRenderFns } from "./updata.vue?vue&type=template&id=2fe4c2b9&scoped=true&"
import script from "./updata.vue?vue&type=script&lang=ts&"
export * from "./updata.vue?vue&type=script&lang=ts&"
import style0 from "./updata.vue?vue&type=style&index=0&id=2fe4c2b9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe4c2b9",
  null
  
)

export default component.exports